import React from "react";
import "../Lectures/Lectures.css";
import Navbar from "../Navbar/Navbar";

function Lectures() {
  return (
    <>
      <Navbar />
      <hr />
      <div className="divcc">
        <div className="Lectures">
          <h2 className="h22">Lectures</h2>
        </div>
      </div>
      <div className="lecturs">
        <div className="Lecturess">
          <div className="all-lect">
            <div className="detls">
              <h3 className="h3">Scrum 25.07.2022</h3>
              <p>
                <strong>Swanand Kadam</strong> Scheduled <strong>Scrum</strong>{" "}
                at 10 Aug, 22 - 9:00 am <button className="live">live</button>
              </p>
            </div>
            <div className="details">
              <button className="dbtnsa">Absent</button>{" "}
            </div>
          </div>
          <hr />
          <div className="all-lect">
            <div className="detls">
              <h3 className="h3">Thrive Regular Standup [week-8]</h3>
              <p>
                <strong>Swanand Kadam</strong> Scheduled{" "}
                <strong>Coding</strong> at 10 Aug, 22 - 12:00 pm{" "}
                <button className="live">live</button>
              </p>
            </div>
            <div className="details">
              <button className="dbtnsa">Absent</button>{" "}
            </div>
          </div>
          <hr />
          <div className="all-lect">
            <div className="detls">
              <h3 className="h3">Scrum 12.07.2022</h3>
              <p>
                <strong>Swanand Kadam</strong> Scheduled <strong>Scrum</strong>{" "}
                at 12 Jul, 22 - 9:00 am <button className="live">live</button>
              </p>
            </div>
            <div className="details">
              <button className="dbtnsa">Absent</button>{" "}
            </div>
          </div>
          <hr />
          <div className="all-lect">
            <div className="detls">
              <h3 className="h3">Thrive Regular Standup [week-8]</h3>
              <p>
                <strong>Swanand Kadam</strong> Scheduled{" "}
                <strong>Coding</strong> at 11 Jul, 22 - 12:00 pm{" "}
                <button className="live">live</button>
              </p>
            </div>
            <div className="details">
              <button className="dbtnsa">Absent</button>{" "}
            </div>
          </div>
          <hr />
          <div className="all-lect">
            <div className="detls">
              <h3 className="h3">Scrum 09.07.2022</h3>
              <p>
                <strong>Swanand Kadam</strong> Scheduled <strong>Scrum</strong>{" "}
                at 09 Jul, 22 - 9:00 am <button className="live">live</button>
              </p>
            </div>
            <div className="details">
              <button className="dbtnsa">Absent</button>{" "}
            </div>
          </div>
          <hr />
          <div className="all-lect">
            <div className="detls">
              <h3 className="h3">Scrum 08.07.2022</h3>
              <p>
                <strong>Swanand Kadam</strong> Scheduled <strong>Scrum</strong>{" "}
                at 08 Jul, 22 - 9:00 am <button className="live">live</button>
              </p>
            </div>
            <div className="details">
              <button className="dbtnsa">Absent</button>{" "}
            </div>
          </div>
          <hr />
          <div className="all-lect">
            <div className="detls">
              <h3 className="h3">Scrum 07.07.2022</h3>
              <p>
                <strong>Swanand Kadam</strong> Scheduled <strong>Scrum</strong>{" "}
                at 07 Jul, 22 - 9:00 am <button className="live">live</button>
              </p>
            </div>
            <div className="details">
              <button className="dbtnsa">Absent</button>{" "}
            </div>
          </div>
          <hr />
          <div className="all-lect">
            <div className="detls">
              <h3 className="h3">Scrum 06.07.2022</h3>
              <p>
                <strong>Swanand Kadam</strong> Scheduled <strong>Scrum</strong>{" "}
                at 06 Jul, 22 - 9:00 am <button className="live">live</button>
              </p>
            </div>
            <div className="details">
              <button className="dbtnsa">Absent</button>{" "}
            </div>
          </div>
          <hr />
          <div className="all-lect">
            <div className="detls">
              <h3 className="h3">Thrive Regular Standup [week-8]</h3>
              <p>
                <strong>Swanand Kadamu</strong> Scheduled{" "}
                <strong>Coding</strong> at 10 Aug, 22 - 12:00 pm{" "}
                <button className="live">live</button>
              </p>
            </div>
            <div className="details">
              <button className="dbtnsa">Absent</button>{" "}
            </div>
          </div>
          <hr />
          <div className="all-lect">
            <div className="detls">
              <h3 className="h3">Thrive Regular Standup [week-8]</h3>
              <p>
                <strong>Swanand Kadam</strong> Scheduled{" "}
                <strong>Coding</strong> at 10 Aug, 22 - 12:00 pm{" "}
                <button className="live">live</button>
              </p>
            </div>
            <div className="details">
              <button className="dbtnsa">Absent</button>{" "}
            </div>
          </div>
          <hr />
          <div className="all-lect">
            <div className="detls">
              <h3 className="h3">Thrive Regular Standup [week-8]</h3>
              <p>
                <strong>Swanand Kadam</strong> Scheduled{" "}
                <strong>Coding</strong> at 10 Aug, 22 - 12:00 pm{" "}
                <button className="live">live</button>
              </p>
            </div>
            <div className="details">
              <button className="dbtnsa">Absent</button>{" "}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Lectures;
